import { render, staticRenderFns } from "./DropdownNotification.vue?vue&type=template&id=65bc4261&scoped=true"
import script from "./DropdownNotification.vue?vue&type=script&lang=js"
export * from "./DropdownNotification.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/notifications/in-app-notifications.scss?vue&type=style&index=0&id=65bc4261&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc4261",
  null
  
)

export default component.exports